import { RendererContextType } from '../../../../contexts/RendererContext';
import { ProjectByIdQuery } from '../../../../types/graphqlTypes';
import { PointoramaOutline } from '../../../../potree/utils/PointoramaOutline';
import { SyncConfig } from './syncFromGraphQL';

type Project = ProjectByIdQuery['projectById'];
type Annotation = Project['state']['annotations'][number];

export function createSyncOutlinesConfig({ viewer, annotations }: { viewer: NonNullable<RendererContextType['viewer']>; annotations: Annotation[] }): SyncConfig<Annotation, PointoramaOutline> {
  return {
    getSourceItems: () => annotations.filter((a) => a.type === 'OUTLINE'),
    getSceneItems: () => [...(viewer.scene.outlines || [])],
    getSourceIdentifier: (item) => item.identifier,
    getSceneIdentifier: (item) => item.identifier,
    // update() omitted — geometry updates are handled by reactive property subscriptions
    create: (source) => {
      const outline = new PointoramaOutline(viewer);
      outline.identifier = source.identifier;
      outline.groupIdentifier = source.groupIdentifier || null;
      outline.finished = true;
      return outline;
    },
    addToScene: (item) => viewer.scene.addOutline(item),
    removeFromScene: (item) => viewer.scene.removeOutline(item),
  };
}
